<template>
  <div :style="style.container">
    <RouterLinkBackSecondary :to="{ name: 'teamup-select' }">
      Back to team selection
    </RouterLinkBackSecondary>
    <div :style="style.innerContainer">
      <HeaderLargePrimary :style="style.header">
        {{ tenantTeam.name }}
      </HeaderLargePrimary>
      <SelectPopoverPrimary
        v-if="!viewOnly"
        :disableSelectState="true"
        horizontalPosition="right"
        :options="options"
        @select="selectOption"
        :style="style.select"
      >
        <template v-slot:select>
          <IconMorePrimary
            v-bind="attrs.icon"
            :style="style.icon"
          />
        </template>
      </SelectPopoverPrimary>
    </div>
  </div>
</template>

<script>
  import HeaderLargePrimary from '@modules/text/header-large-primary'
  import IconMorePrimary from '@modules/icon/icon-more-primary'
  import RouterLinkBackSecondary from '@modules/link/router-link-back-secondary'
  import SelectPopoverPrimary from '@modules/select/select-popover-primary'
  import { Layout } from '@js/styles'
  import { Z_INDEXES } from '@js/constants'
  import { mapState } from 'vuex'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'Header',
    components: {
      HeaderLargePrimary,
      IconMorePrimary,
      RouterLinkBackSecondary,
      SelectPopoverPrimary,
    },
    props: {
      tenantTeam: { type: Object, required: false, default: () => {} },
      tenantTeamPermissions: { type: Array, required: false, default: () => [] },
      viewOnly: { type: Boolean, required: false, default: true },
    },
    data: function () {
      return {
        options: [
          { label: 'Share', },
          { label: 'Rename team', },
          { label: 'Delete team', },
        ],
        attrs: {
          icon: {
            fontSize: '16px',
          },
        },
        style: {
          container: {
            alignItems: 'flex-start',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: '0 12px',
            width: '100%',
          },
          header: {
            display: 'block',
            margin: '12px 0 0 0',
          },
          icon: {
            cursor: 'pointer',
            display: 'block',
            margin: `0 0 0 ${Layout.space.md}`,
          },
          innerContainer: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          },
          select: {
            zIndex: Z_INDEXES.TEAMUP.HEADER_DROPDOWN,
          },
        },
      };
    },
    computed: {
      ...mapState({
        tenantName: state => state.tenant.name,
      }),
    },
    methods: {
      selectOption: function (optionIndex) {
        if (optionIndex === 0) {
          const payload = {
            tenantTeamId: this.tenantTeam.id,
            tenantTeamName: this.tenantTeam.name,
            tenantName: this.tenantName,
            tenantTeamPermissions: this.tenantTeamPermissions,
            code: this.tenantTeam.code,
          };
          this.$modal.show(MODAL_WINDOW_NAMES.SHARE_TENANT_TEAM_LINK_PRIMARY, payload);
        } else if (optionIndex === 1) {
          const payload = {
            tenantTeamId: this.tenantTeam.id,
            tenantTeamName: this.tenantTeam.name,
          };
          this.$modal.show(MODAL_WINDOW_NAMES.RENAME_TENANT_TEAM_PRIMARY, payload);
        } else if (optionIndex === 2) {
          const payload = {
            tenantTeam: this.tenantTeam,
          };
          this.$modal.show(MODAL_WINDOW_NAMES.DELETE_TENANT_TEAM_PRIMARY, payload);
        }
      },
    },
  };
</script>
